module.exports = __webpack_public_path__ + "572f363dcb5aae1a7f911993115a203f.fbx";